// assets js
// import '../../node_modules/bootstrap/dist/js/bootstrap';
import '../../node_modules/bootstrap/dist/js/bootstrap.bundle'

import { load } from 'recaptcha-v3'

load('6LddPfcpAAAAAAyy3ziiIBd7KeaG0tZMus1gEKam').then((recaptcha) => {
  recaptcha.execute('<action>').then((token) => {
  })
})